import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import TopUpStatusMessage from './TopUpStatusMessage';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import { useQuery } from '@tanstack/react-query';

export const NotTopUpEligible = () => {
    const stateKey = useStateKey();

    const {
        data: customerStateRepsponse,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey })
    });

    if (isLoading || isError) return null;

    const companyName =
        customerStateRepsponse.data.application!.company!
            .registered_company_name;

    return (
        <TopUpStatusMessage
            heading="Sorry, you can't request more funds at the moment"
            description={
                <>
                    <strong>{companyName}</strong> isn't eligible for additional
                    funding - feel free to give your account manager a call if
                    you'd like to know more.
                </>
            }
            ctaText="Get in touch"
        />
    );
};
